import { AUTH_BROAD_CAST_CHANNEL } from "./BROAD_CAST_CONSTANT";

export const authChannel = new BroadcastChannel(AUTH_BROAD_CAST_CHANNEL.root);
